import styled from 'styled-components';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { ReactComponent as SvgChat } from '@img/icons/chat-icon.svg';
import animationCurve from '@helpers/animation';
const ChatBtn = styled.button `
  background-color: ${brand.white};
  color: ${brand.sage.sageDark};
  border: none;
  border-radius: 1000000px;
  padding-left: 50px;
  padding-right: 20px;
  position: relative;
  height: 39px;

  @media ${from(Device.DesktopSmall)} {
    height: 54px;
    padding-left: 70px;
    padding-right: 30px;
  }
`;
const ChatBtnTxt = styled.span `
  ${fonts.matter.medium};  
  font-size: 16px;
  line-height: 20px;
  display: inline-block;
  vertical-align: middle;

  @media ${from(Device.DesktopSmall)} {
    font-size: 20px;
    line-height: 28px;
  }
`;
const IconHolder = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 39px;
  height: 39px;
  color: ${brand.white};
  background-color: ${brand.sage.sageDark};
  border-radius: 1000000px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.3s, background-color 0.3s;
  transition-timing-function: ${animationCurve.secondary};

  @media ${from(Device.DesktopSmall)} {
    width: 54px;
    height: 54px;
  }

  ${ChatBtn}:hover &,
  ${ChatBtn}:focus & {
    background-color: ${brand.sage.sageMedium};
  }
`;
const ChatSvg = styled(SvgChat) `
  width: 15px;
  transition: transform 0.2s;
  transition-timing-function: ${animationCurve.secondary};

  @media ${from(Device.DesktopSmall)} {
    width: 25px;
  }

  ${ChatBtn}:hover &,
  ${ChatBtn}:focus & {
    transform: rotate(-15deg);
  }
`;
const ChatButtonStyles = {
    ChatBtn,
    ChatBtnTxt,
    ChatSvg,
    IconHolder,
};
export default ChatButtonStyles;
